export function formatInvoiceAddress(parts: Array<string | undefined | null>): string {
  return parts.filter(Boolean).join(', ');
}

export function formatInvoiceOrderDate(dateStr: string | undefined): string {
  if (!dateStr) return '—';
  try {
    return new Date(dateStr).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });
  } catch {
    return dateStr;
  }
}
